// jsdom's `window.location` can't be stubbed, so tests mock this module instead.
export const navigateTo = (url: string) => {
  window.location.href = url;
};
